import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Avatar, Grid, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@mui/material';
import { Folder as FolderIcon } from '@mui/icons-material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, MultiButton, SquareChip, Text, useSettings } from 'app/main/components';
import buttons from './DocumentsButtons';

export default function DocumentsFoldersListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const imageBasePath = `${import.meta.env.VITE_ENDPOINT}/resources/documents-folders/thumbnails`;
	const avatar = (
		<Avatar
			className="h-64 w-64"
			variant="rounded"
			src={props.model.fold_image ? `${imageBasePath}/${props.model.fold_image}?v=${Date.now()}` : undefined}
		>
			<FolderIcon fontSize="large" />
		</Avatar>
	);

	return (
		<GridListItem buttons={buttons.view?.itemButtons} avatar={avatar}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 600 ? 8 : 12 }}>
					<Grid container>
						<Grid size={12}>
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'sys_documents_folders', uid: props.model.fold_uid }}
							>
								{props.model.fold_title}
							</Text>
						</Grid>
						<Grid size={12}>
							{/* DESCRIPTION */}
							<Text variant="subtitle2" color="text.secondary">
								{props.model.fold_description || <i>{t('VIEW_ITEM_NO_DESCRIPTION')}</i>}
							</Text>
						</Grid>
						{!props.model.fold_active && (
							<Grid>
								{/* ACTIVE */}
								<SquareChip
									icon={<Icon icon="eye-off" size={18} />}
									label={t('IS_HIDDEN')}
									backgroundColor={theme => theme.palette.warning.main}
								/>
							</Grid>
						)}
						<Grid>
							{/* VISIBILITY */}
							<SquareChip
								label={
									<FormattedMessage
										id="deleteDialog.title"
										defaultMessage={t('VISIBILITY_LEVEL')}
										values={{ level: t(`${props.model.fold_visibility}_LEVEL_TITLE`) }}
									/>
								}
							/>
						</Grid>
						{props.model.fold_personal && (
							<Grid>
								{/* PERSONAL */}
								<SquareChip label={t('IS_PERSONAL')} />
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
